var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowReviewBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.392 10.647A3.002 3.002 0 0 1 6.16 8.995H3.37l1.338 1.318c.172.178.287.41.282.683-.01.536-.524.995-.99.995-.465 0-.63-.187-.747-.294L.281 8.682A.956.956 0 0 1 0 7.994a.971.971 0 0 1 .294-.687l3.01-3.028a.973.973 0 0 1 .697-.27c.536.01.998.485.989 1.021a.971.971 0 0 1-.295.687L3.37 6.997h2.79a3.002 3.002 0 0 1 4.106-1.716l2.416-2.277-1.732.004a.99.99 0 0 1-.679-.329.978.978 0 0 1 .05-1.378c.199-.186.459-.315.714-.3l4.012.005c.248.009.493.1.68.3.185.2.273.45.264.699L15.99 6.05a.973.973 0 0 1-.314.679 1.03 1.03 0 0 1-1.421-.048.971.971 0 0 1-.265-.699V4.29L11.65 6.602c.219.416.343.89.343 1.394 0 .451-.1.88-.279 1.263L14 11.68l-.004-1.73a.982.982 0 0 1 .323-.68.978.978 0 0 1 1.378.049c.187.2.316.46.3.714l-.004 4.011a.983.983 0 0 1-.3.691.972.972 0 0 1-.7.265l-4.046-.001a.987.987 0 0 1-.679-.326 1.017 1.017 0 0 1 .048-1.41.972.972 0 0 1 .699-.265h1.693l-2.315-2.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowReviewBranch);
export default __webpack_public_path__ + "static/media/flow-review-branch.55720295ae5d13b867ea6eea7d0b6de2.svg";
export { ForwardRef as ReactComponent };